import { render, staticRenderFns } from "./VPSForgotPwdResetComponent.vue?vue&type=template&id=4bd666cd&scoped=true"
import script from "./VPSForgotPwdResetComponent.vue?vue&type=script&lang=js"
export * from "./VPSForgotPwdResetComponent.vue?vue&type=script&lang=js"
import style0 from "./VPSForgotPwdResetComponent.vue?vue&type=style&index=0&id=4bd666cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd666cd",
  null
  
)

export default component.exports